export enum KeyboardKeys {
  BACKSPACE = 'Backspace',
}
